export const UserRoles = {
    ADMINISTRATOR: "Адміністратор",
};